import { extendTheme } from '@chakra-ui/react';

const ToastNotification = {
  baseStyle: {
    py: 2,
    px: 4,
    width: 'auto',
    color: 'white',
  },
  sizes: {
    'full-width': {
      width: '100%',
      maxWidth: '100%',
    },
  },
  variants: {
    default: {
      backgroundColor: 'resre-prussian-blue',
    },
    warning: {
      bg: 'orange.500',
    },
    success: {
      bg: 'green.500',
    },
    error: {
      bg: 'red.500',
    },
  },
  defaultProps: {
    variant: 'default',
  },
};

export const globalTheme = extendTheme({
  styles: {
    global: {
      '*, *:before, *:after': {
        position: 'relative',
        boxSizing: 'border-box',
      },
      'html, body, #root': {
        margin: 0,
        padding: 0,
        minHeight: '100vh',
        background: 'white',
        color: 'black',
        lineHeight: 1.5,
        fontSize: '14px',
        fontWeight: 400,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      },
      '#root': {
        display: 'flex',
        overflowX: 'hidden',
        flexDirection: 'column',
      },
      'h1,h2,h3,h4,h5,h6': {
        margin: 0,
      },
      hr: {
        border: '1px solid',
        borderColor: 'gray.100',
      },

      // Override toast container styles in order to support custom toasts
      '.chakra-toast__inner': {
        display: 'flex',
        justifyContent: 'center',
        width: '100% !important',
        maxWidth: '100% !important',

        // Apply default styles so that the vanilla Chakra toasts render as intended
        '.chakra-alert': {
          margin: '0.5rem',
          maxWidth: '560px',
          minWidth: '300px',
          pointerEvents: 'auto',
        },
      },
    },
  },
  colors: {
    'resre-prussian-blue': '#003057',
  },
  components: {
    ToastNotification,
    Table: {
      variants: {
        'file-browser': {
          thead: {
            borderBottom: '1px solid',
            borderBottomColor: 'gray.100',
          },
          th: {
            fontSize: 'md',
            letterSpacing: '0',
            textTransform: 'capitalize',
            display: { base: 'none', md: 'table-cell' },
            '&:first-of-type': {
              pl: 0,
              display: { base: 'table-cell' },
            },
          },
          td: {
            border: 'none',
            display: { base: 'none', md: 'table-cell' },
            '&:first-of-type': {
              pl: 0,
              maxWidth: '80',
              display: { base: 'table-cell' },
            },
          },
        },
      },
    },
  },
  layerStyles: {
    border: {
      border: '1px solid',
      borderColor: 'gray.200',
      borderRadius: 'md',
    },
  },
  textStyles: {
    title: {
      fontSize: '2rem',
      fontWeight: 'bold',
    },
    subtitle: {
      fontWeight: '500',
    },
    breadcrumb: {
      fontSize: '1.8rem',
      fontWeight: 'bold',
    },
  },
});
